import * as Sentry from '@sentry/astro';

import { config } from './config';

Sentry.init({
  ...config,
  integrations: [
    Sentry.thirdPartyErrorFilterIntegration({
      filterKeys: [__SENTRY_APP_KEY__],
      behaviour: __SENTRY_THIRD_PARTY_FILTER_BEHAVIOR__,
    }),
  ],
});
